import { render, staticRenderFns } from "./AdditionalFieldChangeRequestsQueue.vue?vue&type=template&id=17a4230e&scoped=true&"
import script from "./AdditionalFieldChangeRequestsQueue.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldChangeRequestsQueue.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFieldChangeRequestsQueue.vue?vue&type=style&index=0&id=17a4230e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a4230e",
  null
  
)

export default component.exports